exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inTotal[data-v-8fb8bf48]{margin:0;line-height:32px;margin-right:14px}.title[data-v-8fb8bf48]{font-size:16px;font-weight:500}[data-v-8fb8bf48] el-tag{border:none}\n", ""]);

// exports
